{
  "allApps": "All Apps",
  "back": "Back to main",
  "myApps": "My Apps",
  "viewMoreApps": "View more apps"
} 
